<template>
    <q-list dense separator>
        <q-item ref="name" v-if="!isHidden.name">
            <q-item-section avatar>
                <q-icon name="mdi-account" class="text-grey-7" />
            </q-item-section>
            <q-item-section :class="{'text-primary': !$q.dark.isActive, 'text-secondary': $q.dark.isActive}">
                {{ contact.first_name }} {{ contact.last_name ?? '' }}
            </q-item-section>
        </q-item>
        <q-item ref="email" v-if="!isHidden.email">
            <q-item-section avatar>
                <q-icon name="mdi-email" class="text-grey-7" />
            </q-item-section>
            <q-item-section :class="{'text-primary': !$q.dark.isActive, 'text-secondary': $q.dark.isActive}">
                {{ contact.email }}
            </q-item-section>
            <q-item-section side>
                <q-btn
                    icon="mdi-content-copy"
                    color="primary"
                    @click="navigator.clipboard.writeText(contact.email)"
                    size="sm"
                    round
                    flat
                >
                    <q-tooltip>Copy</q-tooltip>
                </q-btn>
            </q-item-section>
        </q-item>
        <q-item ref="phone" v-if="!isHidden.phone">
            <q-item-section avatar>
                <q-icon name="mdi-phone" class="text-grey-7" />
            </q-item-section>
            <q-item-section :class="{'text-primary': !$q.dark.isActive, 'text-secondary': $q.dark.isActive}">
                {{ contact.phone }}
            </q-item-section>
            <q-item-section side>
                <q-btn
                    icon="mdi-content-copy"
                    color="primary"
                    @click="navigator.clipboard.writeText(contact.phone)"
                    size="sm"
                    round
                    flat
                >
                    <q-tooltip>Copy</q-tooltip>
                </q-btn>
            </q-item-section>
        </q-item>
        <q-item ref="mobile" v-if="!isHidden.mobile">
            <q-item-section avatar>
                <q-icon name="mdi-cellphone" class="text-grey-7" />
            </q-item-section>
            <q-item-section :class="{'text-primary': !$q.dark.isActive, 'text-secondary': $q.dark.isActive}">
                {{ contact.mobile }}
            </q-item-section>
            <q-item-section side>
                <q-btn
                    icon="mdi-content-copy"
                    color="primary"
                    @click="navigator.clipboard.writeText(contact.phone)"
                    size="sm"
                    round
                    flat
                >
                    <q-tooltip>Copy</q-tooltip>
                </q-btn>
            </q-item-section>
        </q-item>
        <q-item ref="fax" v-if="!isHidden.fax">
            <q-item-section avatar>
                <q-icon name="mdi-fax" class="text-grey-7" />
            </q-item-section>
            <q-item-section :class="{'text-primary': !$q.dark.isActive, 'text-secondary': $q.dark.isActive}">
                {{ contact.fax }}
            </q-item-section>
            <q-item-section side>
                <q-btn
                    icon="mdi-content-copy"
                    color="primary"
                    @click="navigator.clipboard.writeText(contact.fax)"
                    size="sm"
                    round
                    flat
                >
                    <q-tooltip>Copy</q-tooltip>
                </q-btn>
            </q-item-section>
        </q-item>
        <q-item ref="address" v-if="!isHidden.address">
            <q-item-section avatar>
                <q-icon name="mdi-map-marker" class="text-grey-7" />
            </q-item-section>
            <q-item-section :class="{'text-primary': !$q.dark.isActive, 'text-secondary': $q.dark.isActive}">
                <div>{{ contact.street_address }}{{ contact.suite ? ', ' + contact.suite : '' }}{{ contact.sub_suite ? '-' + contact.sub_suite : '' }}</div>
                <div>{{ contact.city }}, {{ contact.state }} {{ contact.postal_code }}</div>
            </q-item-section>
            <q-item-section side>
                <q-btn
                    icon="mdi-content-copy"
                    color="primary"
                    @click="navigator.clipboard.writeText(`${contact.street_address + (contact.suite ? ', ' + contact.suite : '') + (contact.sub_suite ? '-' + contact.sub_suite : '')}\n${contact.city}, ${contact.state} ${contact.postal_code}`)"
                    size="sm"
                    round
                    flat
                >
                    <q-tooltip>Copy</q-tooltip>
                </q-btn>
            </q-item-section>
        </q-item>

        <q-item v-if="isHidden.everything">
            <q-item-section class="text-center text-blue-grey-4 q-pa-sm">
                <q-item-label class="text-subtitle1 flex justify-center" style="align-items: center;">
                    <q-icon
                        name="mdi-information-outline"
                        :size="$q.screen.lt.xl ? 'sm':'1.25rem'"
                        class="q-mr-xs"
                    />
                    No contact information available.
                </q-item-label>
            </q-item-section>
        </q-item>
    </q-list>
</template>

<script>
export default {
    name: 'ContactViewModel',
    props: {
        contact: {
            type: Object,
            required: true,
        },
        striped: {
            type: Boolean,
            default: false,
        },
        stripedColor: {
            type: String,
            default: 'grey-2',
        },
    },
    data() {
        return {
            navigator: window.navigator,
        };
    },
    methods: {
        stripeItems() {
            if (!this.striped) return;

            const keys = Object.keys(this.$refs);

            keys.forEach((key) => {
                if (this.$refs[key] && keys.indexOf(key) % 2 === 0) {
                    if (this.stripedColor.includes('#')) {
                        this.$refs[key].$el.style.backgroundColor = this.stripedColor;
                        return;
                    }

                    this.$refs[key].$el.classList.add('bg-' + this.stripedColor);
                }
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.stripeItems();
        });
    },
    computed: {
        isHidden() {
            const isHidden = {
                name: !(this.contact?.first_name ?? false) && !(this.contact?.last_name ?? false),
                email: !(this.contact?.email ?? false),
                phone: !(this.contact?.phone ?? false),
                mobile: !(this.contact?.mobile ?? false),
                fax: !(this.contact?.fax ?? false),
                address: !(this.contact?.street_address ?? false) && !(this.contact?.city ?? false) && !(this.contact?.state ?? false) && !(this.contact?.postal_code ?? false),
            }

            return {
                ...isHidden,
                everything: Object.values(isHidden).reduce((a, b) => a && b)
            }
        }
    }
};
</script>